export class EditLaneModel {
  Id?: number;
  IsSendTone = false;
  IsActive = true;
  Lane_Number?: number;
  FacilityLaneCode?: number = null;
  Intercom_Installed?: number = null;
  Intercom_Manufacturer?: number = null;
  Intercom_InstallDate?: Date = null;
  Intercom_Type = '';
  fkLot?: number = null;
  Gate_Vend_Code: string;
  TerminateCallTone: string = null;
  VoicePlatformDeviceId?: string;
  VoicePlatformDeviceName?: string;
  VoicePlatformDeviceCreated?: Date = null;
  IsNew = false;
  Lane_Type?: string;
  Accept_Payments: boolean | null;
  VoipExt: string;
  DialNumber: number;
  InexLaneId?: number;
  VideoStreamDirection: VideoStreamDirection;
  // VideoSources: ILaneVideoSources[] = [];
  // Example of Video_Settings value:
  // [{"StreamSource":1,"DVR_Channel":"7"}]
  // or
  // [{"StreamSource":3,"CameraId":"1"},{"StreamSource":3,"CameraId":"3"}]
  // or
  // [{"StreamSource":2,"RtspAddress":"rtsp:\/\/104.37.234.230:554\/chID=4&streamType=main","RtspUsername":"admin","RtspPassword":"!!Admin$$","RtspTransport":0}]
  Video_Settings: string;
  VoicePlatformDeviceStatus: DeviceStatus;
}

export interface ILaneVideoSources {
  editMode?: boolean;
  IsPrimary?: boolean;
  ProviderType?: string;
  ProviderName?: string;
  Code?: string;
  UserName?: string;
  Password?: string;
  ProviderIP?: string;
  Guid?: string;
  StreamSource: IStreamSourceType;
  RtspTransport?: IRTSPTransportType;
  RtspAddress?: string;
  RtspUsername?: string;
  RtspPassword?: string;
  DialNumber?: number;
  Axxon_Cameras: string;
  DVR_Channel?: string;
  CameraId?: string;
}

export enum IStreamSourceType {
  None = 0,
  Dvr = 1,
  Rtsp = 2,
  Axxon = 3,
}

export enum IRTSPTransportType {
  UDP,
  TCP,
}

export enum VideoStreamDirection {
  Disabled = 0,
  OneWay = 1,
  // keep it till final decision
  // TwoWay = 2,
}

export enum DeviceStatus {
  Unavailable,
  Unregistered,
  Registered,
}

export const RTSP_TRANSPORT_TYPES = [
  { Id: 0, Name: 'UDP' },
  { Id: 1, Name: 'TCP' },
];

export const STREAM_SOURCE_TYPES = [
  { Id: 0, Name: 'None' },
  { Id: 1, Name: 'DVR' },
  { Id: 2, Name: 'RTSP' },
  { Id: 3, Name: 'NexShield NVR', disabled: true },
];

export const VIDEO_STREAM_DIRECTIONS = [
  { Id: 0, Name: 'Disabled' },
  { Id: 1, Name: 'One-Way Video' },
  // keep it till final decision
  // { Id: 2, Name: 'Two-Way Video' },
];

export function getRTSPTransportTypeNameById(id: number) {
  return RTSP_TRANSPORT_TYPES.find((type: { Id: number; Name: string }) => type.Id === id)?.Name || '';
}
